import { render } from "./CriterionPercentile.vue?vue&type=template&id=4f5a457d"
import script from "./CriterionPercentile.vue?vue&type=script&lang=js"
export * from "./CriterionPercentile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__